import { DefaultsInterface } from '../../interfaces/defaults/defaults-interface';

export class DefaultsModel implements DefaultsInterface {
  country: string = '';
  countryCode: string = '';
  phoneLength: number[] = new Array<number>();
  phonePrefix: string = '';
  prefixRestrictions: string[] = new Array<string>();

  constructor(init?: Partial<DefaultsModel>) {
    Object.assign(this, init);
  }
}
